var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"channel-report"},[_c('div',[_c('router-view',{attrs:{"isCollapse":_vm.isCollapse}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }